<div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Reporting to Client Head
        </div>
        <div class="card-body p-1">
            <div class="row m-1">
                <div class="col-md-1 px-1">
                    <label class="Label">Client:</label>
                </div>
                <div class="col-md-5 px-1">
                    <ng-select name="client" [items]="ClientLoad" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" [(ngModel)]="ClientId"
                        (change)="onSelectChange('Client'); ComboLoad('Site');clear()" placeholder="Select Client">
                        <ng-option *ngFor="let segment of ClientLoad" [value]="segment.ClientGroupMasterID">
                            {{ segment.ClientGroupName }}
                        </ng-option>
                    </ng-select>
                </div>
                <div class="col-md-2 px-1">
                    <button class="btn btn-primary" name="search" (click)="Search()">
                        <i class="bi bi-search" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Search':'Loading...'}}
                    </button>
                </div>
            </div>
            <div>
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th scope="col" style="width: 3%;">#</th>
                            <th scope="col" style="display: none;"> Client Master ID</th>
                            <th scope="col"> Client Name</th>
                            <th scope="col" class="narrow-column">Reporting Approval</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let site of ClientDataLoad; let i = index">
                            <th scope="row">{{ i + 1 }}</th>
                            <td style="display: none;">{{ site['ClientGroupMasterID'] }}</td>
                            <td>{{ site['ClientGroupName'] }}</td>
                            <td class="narrow-column">
                                <select class="form-select narrow-dropdown ng-select" name="reportmanager1" [(ngModel)]="site.ClientOwnerId">
                                    <option [value]="0">Select</option>
                                    <option *ngFor="let manager of UserLoad" [value]="manager.UserMasterId">
                                        {{ manager.UserName }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                    <div class="row">
                    </div>
                    <div class="row">
                    </div>
                </div>
                <div class="col-auto">
                    <button class="btn btn-primary" name="save" (click)="save()" *ngIf="this.common.PageRight.IsEdit">
                        <i class="bi bi-save" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>